import { Message } from "../components/Assistant/AssistantContext";

export interface MessageGroup {
  time: string;
  messages: Message[];
}

export const groupMessagesByTime = (msgs: Message[]): MessageGroup[] => {
  const groups: MessageGroup[] = [];
  
  msgs.forEach((msg) => {
    const msgTime = new Date(msg.timestamp);
    const timeStr = msgTime.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    
    // Check if we should add to existing group or create new one
    const lastGroup = groups[groups.length - 1];
    // Compare minute values instead of time strings to avoid grouping messages from different days
    if (lastGroup && Math.floor(lastGroup.messages[0].timestamp / 60000) === Math.floor(msg.timestamp / 60000)) {
      // Same minute, add to existing group
      lastGroup.messages.push(msg);
    } else {
      // New time, create new group
      groups.push({
        time: timeStr,
        messages: [msg]
      });
    }
  });
  
  return groups;
};
